import { render, staticRenderFns } from "./OnHoldModal.vue?vue&type=template&id=30969b21&scoped=true&"
import script from "./OnHoldModal.vue?vue&type=script&lang=js&"
export * from "./OnHoldModal.vue?vue&type=script&lang=js&"
import style0 from "./OnHoldModal.vue?vue&type=style&index=0&id=30969b21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30969b21",
  null
  
)

export default component.exports